import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateSpecificBranch = (
  scopes: string[],
  evaluatorParams: ScopeValues | undefined
) => {
  if (isNil(evaluatorParams) || !('branchId' in evaluatorParams)) {
    return false;
  }

  if (evaluatorParams.branchId === 'SKIP') {
    return true;
  }

  return scopes.includes(evaluatorParams.branchId ?? '');
};
